import React from "react";
import useFetch from "use-http";
import { Box, Text } from "@theme-ui/components";

const Embed = ({ url, caption, insideGroup }) => {
  const isDataWrapper = url.includes("://datawrapper");
  const fetchUrl = `https://iframe.ly/api/oembed?url=${url}&api_key=66960ca1673cac2a2e8705`;
  const [data] = useFetch(fetchUrl, {}, []);
  return (
    <Box
      sx={{
        breakInside: "avoid",
        pageBreakInside: "avoid",
        mb: [3, 4, 5],
        background: isDataWrapper ? "white" : null,
        px: isDataWrapper ? [3, 4] : null,
        borderRadius: isDataWrapper ? 15 : null,
      }}
    >
      <Box sx={{ overflow: "hidden" }}>
        {data && data.data && data.data.html && (
          <Box
            sx={{
              overflow: "hidden",
              my: [3, 4],
            }}
            dangerouslySetInnerHTML={{ __html: data.data.html }}
          />
        )}
        {caption && (
          <Text
            sx={{ color: "text", p: [3, 4], pt: [0, 0] }}
            as="p"
            variant="paragraph"
          >
            {caption}
          </Text>
        )}
      </Box>
    </Box>
  );
};

export default Embed;
